import { Component, OnInit } from '@angular/core';
import { CommonService } from "../../../../../services/common.service";

@Component({
    selector: 'page-info-refund-finish',
    templateUrl: './index.component.html',
})
export class PageInfoRefundFinishComponent implements OnInit {

    /* REFUND POST DATA */
    public refundPostData: any;

    public _: any;

    constructor(
        public commonService: CommonService
    ) {
        this._ = this.commonService.getLodash();
    }

    async ngOnInit() {
        /* GET POST DATA */
        this.refundPostData = this.commonService.getData("refundPostData");

        /* CLEAR OLD POST DATA */
        this.commonService.removeData("refundPostData");

        /* CHECK IF HAS DATA */
        if (this._.isEmpty(this.refundPostData)) {
            return this.commonService.redirectToRoute(this.commonService.routePaths.pageHome);
        }
    }

}
